var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inv"},[(_vm.pageText)?_c('div',{staticClass:"inv__desc"},[_c('EditorJSComponent',{attrs:{"text":_vm.pageText}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }